module.exports = __webpack_public_path__ + "img/robot.0782b2af.webp";